import { styled } from '@/stitches.config';

export const LabelStyled = styled('label', {
  color: '$darkBlue200',
  fontSize: '$md',
  fontWeight: '$bold',
  lineHeight: '$6',
  mb: '$2',
  mt: '$0',
});
